import type { RecordingFormat } from './api';

/** Candidates in preference order. Labels describe what is actually requested from MediaRecorder. */
const CANDIDATES: ReadonlyArray<RecordingFormat> = [
  { mimeType: 'video/webm;codecs=vp9,opus', label: 'WebM (VP9 + Opus)', container: 'webm', fileExtension: 'webm' },
  { mimeType: 'video/webm;codecs=vp8,opus', label: 'WebM (VP8 + Opus)', container: 'webm', fileExtension: 'webm' },
  { mimeType: 'video/webm;codecs=av1,opus', label: 'WebM (AV1 + Opus)', container: 'webm', fileExtension: 'webm' },
  { mimeType: 'video/webm;codecs=h264,opus', label: 'WebM (H.264 + Opus)', container: 'webm', fileExtension: 'webm' },
  { mimeType: 'video/webm', label: 'WebM (browser default codecs)', container: 'webm', fileExtension: 'webm' },
  { mimeType: 'video/mp4;codecs=avc1.640028,mp4a.40.2', label: 'MP4 (H.264 High + AAC)', container: 'mp4', fileExtension: 'mp4' },
  { mimeType: 'video/mp4;codecs=avc1.4d401f,mp4a.40.2', label: 'MP4 (H.264 Main + AAC)', container: 'mp4', fileExtension: 'mp4' },
  { mimeType: 'video/mp4;codecs=avc1,mp4a.40.2', label: 'MP4 (H.264 + AAC)', container: 'mp4', fileExtension: 'mp4' },
  { mimeType: 'video/mp4;codecs=avc1,opus', label: 'MP4 (H.264 + Opus)', container: 'mp4', fileExtension: 'mp4' },
  { mimeType: 'video/mp4;codecs=av01,opus', label: 'MP4 (AV1 + Opus)', container: 'mp4', fileExtension: 'mp4' },
  { mimeType: 'video/mp4', label: 'MP4 (browser default codecs)', container: 'mp4', fileExtension: 'mp4' },
  { mimeType: 'video/x-matroska;codecs=avc1,opus', label: 'Matroska (H.264 + Opus)', container: 'mkv', fileExtension: 'mkv' },
  { mimeType: 'video/x-matroska;codecs=vp9,opus', label: 'Matroska (VP9 + Opus)', container: 'mkv', fileExtension: 'mkv' },
  { mimeType: 'video/x-matroska;codecs=avc1', label: 'Matroska (H.264)', container: 'mkv', fileExtension: 'mkv' },
  { mimeType: 'video/x-matroska', label: 'Matroska (browser default codecs)', container: 'mkv', fileExtension: 'mkv' },
];

export function listSupportedFormats(): RecordingFormat[] {
  if (typeof MediaRecorder === 'undefined') return [];
  const supported = CANDIDATES.filter((f) => MediaRecorder.isTypeSupported(f.mimeType));
  // A bare container type only adds information when no codec-specific variant of it is available.
  return supported
    .filter((f) => f.mimeType.includes('codecs=') || !supported.some((o) => o !== f && o.container === f.container))
    .map((f) => ({ ...f }));
}

export function extensionForMime(mimeType: string): string {
  const base = mimeType.split(';')[0]!.trim().toLowerCase();
  if (base === 'video/mp4' || base === 'audio/mp4') return 'mp4';
  if (base === 'video/x-matroska') return 'mkv';
  if (base === 'audio/ogg') return 'ogg';
  return 'webm';
}
